import React, { useState, useEffect, useMemo } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView, notification, Widget } from '@digital/ui';
import { getAllProjetoRelatorios } from '@app/api/projeto';
import { hasPermission } from '@app/helpers/permissions';
import ResultCicloAno from './resultCicloAno';
import ResultPluriAnual from './resultCicloPluriAnual';
import DadosGerias from './dadosGerais';

const RelatorioProjetoCicloAnoPluriAnual = () => {
  const [projetos, setProjetos] = useState(() => getAllProjetoRelatorios);
  const idTodos = '00000000-0000-0000-0000-000000000000';
  const urlTodosProjeto =
    '/relatorioProjetoCicloAnoPluriAnual/detail/00000000-0000-0000-0000-000000000000/cicoOrcamentario';
  const idAbaGeral = 'dadosGerais';

  const getValueUrl = () => {
    const latUrl = window.location.pathname.split('/').pop();
    if (latUrl === idAbaGeral) {
      const ulr = window.location.origin;
      const urlFinal = `${ulr}${urlTodosProjeto}`;
      window.location.href = urlFinal;
    }
  };

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      filterPredicate={(item, value) =>
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        (item.numero && item.numero.toLowerCase().includes(value.toLowerCase())) ||
        item.nome.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => (item.id === idTodos ? `${item.nome}` : `${item.codigo} - ${item.nome}`)}
      descriptionExtractor={item => item.statusNome || ''}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          if (selectedItem && selectedItem.id === idTodos) {
            getValueUrl();
            return (
              <CompositeView>
                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="cicoOrcamentario" noform title="CICLO ORÇAMENTARIO">
                    <ResultCicloAno projetoId={selectedItem.id} />
                  </GridView>
                ) : (
                  () => { }
                )}

                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                    <ResultPluriAnual
                      projetoId={selectedItem.id}
                      projetoCodigo={selectedItem.codigo}
                      nomeProjeto={selectedItem.nome}
                    />
                  </GridView>
                ) : (
                  () => { }
                )}
              </CompositeView>
            );
          } else {
            return (
              <CompositeView>
                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id={`${idAbaGeral}`} noform title="DADOS GERAIS">
                    <DadosGerias projetoId={selectedItem.id} />
                  </GridView>
                ) : (
                  () => { }
                )}

                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="cicoOrcamentario" noform title="CICLO ORÇAMENTARIO">
                    <ResultCicloAno projetoId={selectedItem.id} />
                  </GridView>
                ) : (
                  () => { }
                )}

                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                    <ResultPluriAnual
                      projetoId={selectedItem.id}
                      projetoCodigo={selectedItem.codigo}
                      nomeProjeto={selectedItem.nome}
                    />
                  </GridView>
                ) : (
                  () => { }
                )}
              </CompositeView>
            );
          }
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default RelatorioProjetoCicloAnoPluriAnual;
